/** Zgodnie z `prefix-suffix-editor.js` */
export function transformChannelName(name: string, position: 'prefix' | 'suffix', remove: boolean, txt: string): string {
  const s = String(name ?? '');
  const t = String(txt ?? '');
  const len = t.length;
  if (!len) return s;

  if (remove) {
    if (position === 'prefix') {
      return s.substring(0, len) === t ? s.substring(len) : s;
    }
    return s.substring(s.length - len) === t ? s.substring(0, s.length - len) : s;
  }
  if (position === 'prefix') {
    return s.substring(0, len) === t ? s : t + s;
  }
  return s.substring(s.length - len) === t ? s : s + t;
}
